export function dragdrop(state = {}, action) {
  if (action.type === 'SET_IMAGE') {
    return action.file;
  }
  return state;
}
